import Vue from 'vue'
import Vuex from 'Vuex'
import user from './modules/user'
import collectionArr from './modules/collectionArr'
import cartArr from './modules/cartArr'
import getters from './getters'

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        user,
        collectionArr,
        cartArr
    },
    getters
})

export default store;


// WEBPACK FOOTER //
// ./src/store/index.js